import { useState } from "react";
import { Form } from "react-bootstrap";
import PasswordIcon from "../assets/images/PasswordIcon.svg";
import Hide from "../assets/images/hide.svg";


const PasswordInput = ({ value, onChange, placeholder = "Enter Password" }) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <Form.Group className="form-group position-relative">
            <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                className="pr-5" // space for the icon
            />

            <img
                src={showPassword ? PasswordIcon : Hide}
                alt={showPassword ? "Hide password" : "Show password"}
                onClick={() => setShowPassword(!showPassword)}
                style={{
                    position: "absolute",
                    top: "50%",
                    right: "20px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    width: "20px",
                    height: "20px",
                }}
            />
        </Form.Group>
    );
};

export default PasswordInput;
